export class ListarAtendimentos {
    cpf:string;
    diretoria:number;
    tipoBusca:boolean;
}